import {ClutchService} from '../../services/clutch.js'
import {ERROR_MESSAGE, PAYMENT_METHODS} from './constants.js'

export function validateGC(basket, gcLimit, cardNumber) {
    const giftCertificates = basket?.paymentInstruments?.filter(
        (pi) => pi.paymentMethodId === PAYMENT_METHODS.GIFT_CERTIFICATE
    )

    if (giftCertificates?.length >= gcLimit) {
        return {
            error: true,
            msg: ERROR_MESSAGE.MAX_REACHED_GIFT_CERT
        }
    }

    if (basket?.giftCertificateLineItems?.length > 0) {
        return {
            error: true,
            msg: ERROR_MESSAGE.NOT_ALLOWED_GIFT_CERT
        }
    }

    let hasGCApplied = false

    giftCertificates?.forEach((gc) => {
        if (gc?.c_giftCardId === cardNumber.trim()) {
            hasGCApplied = true
        }
    })

    if (hasGCApplied) {
        return {
            error: true,
            msg: ERROR_MESSAGE.ALREADY_EXIST_GIFT_CERT
        }
    }

    return {
        error: false
    }
}

export function calculateAmountToRedeem(basket, balance) {
    const giftCertificates = basket?.paymentInstruments?.filter(
        (pi) => pi.paymentMethodId === PAYMENT_METHODS.GIFT_CERTIFICATE
    )
    let paidWithGiftCard = 0

    giftCertificates?.forEach((gc) => {
        paidWithGiftCard += gc?.amount
    })

    const orderBalance = basket?.orderTotal - paidWithGiftCard

    if (orderBalance < balance) {
        return orderBalance
    }

    return balance
}

export function paidWithGC(basket) {
    const giftCertificates = basket?.paymentInstruments?.filter(
        (pi) => pi.paymentMethodId === PAYMENT_METHODS.GIFT_CERTIFICATE
    )

    let paidWithGiftCard = 0

    giftCertificates?.forEach((gc) => {
        paidWithGiftCard += gc?.amount
    })

    return Number(paidWithGiftCard.toFixed(2))
}

/** Same trusted origin as server-side useOrigin({ fromXForwardedHeader: false }) — `process.env.APP_ORIGIN`. */
const getTrustedAppOrigin = () => {
    const {APP_ORIGIN} = process.env
    if (!APP_ORIGIN) {
        throw new Error(ERROR_MESSAGE.SERVER_ISSUE)
    }
    return APP_ORIGIN
}

export async function placeHoldGC(order, authToken, site, isFullGCPaid, isBoltPaymentSelected) {
    const orderNo = order?.orderNo
    const giftCertificates = order?.paymentInstruments?.filter(
        (pi) => pi.paymentMethodId === PAYMENT_METHODS.GIFT_CERTIFICATE
    )

    try {
        const requestBody = {
            orderNo: orderNo,
            giftCards: giftCertificates
        }

        let holdURL = 'api/clutch/placehold'
        if (!isFullGCPaid && !isBoltPaymentSelected) {
            holdURL = new URL(`${getTrustedAppOrigin()}${'/api/clutch/placehold'}`)
        }

        const service = new ClutchService(authToken, site, holdURL)
        const response = await service.placeHold(requestBody)

        if (response.error) {
            let voidURL = 'api/clutch/voidgiftcard'

            if (!isFullGCPaid) {
                voidURL = new URL(`${getTrustedAppOrigin()}${'/api/clutch/voidgiftcard'}`)
            }
            const voidservice = new ClutchService(authToken, site, voidURL)
            await voidservice.voidGiftCard(orderNo)
            return {error: true}
        }

        return {error: false}
    } catch (e) {
        console.error(e)
        return {error: true}
    }
}
